
import { useTranslation } from 'react-i18next';

export default function LendingCTASection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gradient-to-br from-green-900 via-gray-900 to-teal-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          {t('lending.cta.title')}
        </h2>
        <p className="text-xl text-gray-300 mb-8 leading-relaxed">
          {t('lending.cta.description')}
        </p>
        
        <button 
          className="inline-block bg-green-600 hover:bg-green-700 text-white px-12 py-5 rounded-lg font-semibold text-xl transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer mb-12"
        >
          {t('lending.cta.button')}
        </button>
      </div>
    </section>
  );
}
